export const WHITELIST_URLS_FOR_REQUEST_ERRORS: string[] = [];
export const WHITELIST_URLS_FOR_RESPONSE_ERRORS: string[] = [];